import { createLogger } from 'vue-logger-plugin';

const logger = createLogger({
	enabled: process.env.NODE_ENV !== 'production' || Boolean(new URLSearchParams(window.location.search).get('logger')),
});

export default logger;
